<template>
  <div id="app"> 
    <!-- <headerCom/> -->
    <vue-scroll>
    <div class="router-view-mask"> 
      <!-- {{$route.meta.keepAlive}} -->
      <transition name="el-fade-in">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
      </transition>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
    </vue-scroll>
  </div>
</template>

<script> 
// import headerCom from './components/headerCom/headerCom.vue' 
import { getUserInfo } from "@/api/lxc/index.js" 
export default {
  name: 'App',
  data(){
    return { 
    }
  },
  computed: { 
  },
  methods:{ 
  },
  created(){   


    // const token = this.$cookies.get('token')
    // if(token){ 
    //   getUserInfo().then((res)=>{ 
    //     this.$store.commit("setUserInfo",res.user)
    //     console.log(this.$store.state.userInfo) 
    //   })
    // }else{
    //   // this.router 
    // }

    getUserInfo().then((res)=>{  
        if(res.code === 0 && res.type === "unit" ){
          this.$store.commit("setUserInfo",res.user)
          this.$router.replace("bookList") 
        } else{
          this.$store.commit("setUserInfo",res.user)
          this.$router.replace("bookList") 
        }
      }) 
  },
  mounted(){
    document.oncontextmenu = function(){
        return false;
    }
  },
  components: {
    // headerCom
  }
}
</script>

<style>
html,body,#app{
  height: 100%;
}
.el-message { 
    border-color: #3a3a3a!important; 
    background-color: #eae6de!important; 
}
.el-message i{ 
    color: #3a3a3a!important;  
}
.el-message p{ 
    color: #3a3a3a!important;  
}
</style>
